// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimatedEmoji_container__2CRl9","scaleIn":"AnimatedEmoji_scaleIn__39HrY"};